import Dialog from "../dialogs/Dialog";
import {Box, Button, CircularProgress, DialogContent, DialogTitle, MenuItem, TextField} from "@mui/material";
import React, {ChangeEventHandler, useContext, useEffect, useState} from "react";
import {Database, get, getDatabase, ref} from "@firebase/database";
import {getApp} from "@firebase/app"
import {Projects} from "../../redux/types/firebase";
import {Stop} from "@mui/icons-material";
import {FirebaseTools} from "../../utility/firebaseTools";
import {FirebaseContext} from "../firebase/FirebaseProvider";
import {selectUserId} from "../../redux/selectors/editor";
import {connect} from "react-redux";

const databaseSources: {[key: string]: string} = {
    coding: "https://pathway-coding.europe-west1.firebasedatabase.app",
    develop: "https://pathway-develop-default-rtdb.europe-west1.firebasedatabase.app",
    staging: "https://pathway-staging.europe-west1.firebasedatabase.app",
    release: "https://pathway-release.europe-west1.firebasedatabase.app",
    restore: "https://pathway-temp-0.europe-west1.firebasedatabase.app"
}
interface IImportProject {
    onClose: () => any
    user: string
}
function ImportProjectDialog({onClose, user}: IImportProject) {
    const [importDatabase, setImportDatabase] = useState<Database>();
    const [importPending, setImportPending] = useState<number>();
    const [importProject, setImportProject] = useState("");
    const [importProjects, setImportProjects] = useState<Projects>();
    const [version, setVersion] = useState(0);
    const [tag, setTag] = useState("");
    const {push} = useContext(FirebaseContext);
    const handleImportDeploymentChange: ChangeEventHandler<HTMLInputElement> = ({target}) =>
        setImportSource(target.value);
    const handleImportProjectChange: ChangeEventHandler<HTMLInputElement> = ({target}) =>
        setImportProject(target.value);
    const handleImportClick = async () => {
        if (importDatabase) {
            const fingerprint = await FirebaseTools.ImportFirebase(importDatabase, importProject, (label, progress) => {
                setImportPending(progress);
            });
            setImportPending(undefined);
            push(`versions/${importProject}/import`, {
                fingerprint,
                tag,
                timestamp: Date.now(),
                user,
                version
            }).catch(console.error);
            onClose();
        }
    };
    const importSources: {[key: string]: string[]} = {
        coding: ["develop", "staging", "release", "restore"],
        develop: ["staging", "release", "restore"],
        staging: ["develop", "restore"],
        release: ["staging", "restore"]
    }
    const databaseURL = getDatabase().app.options.databaseURL;
    const deployment = Object.keys(databaseSources).find(key => databaseSources[key] === databaseURL) || "develop";
    const sources = importSources[deployment];
    const [importSource, setImportSource] = useState<string>(sources[0]);
    const handleTagChange: ChangeEventHandler<HTMLInputElement> = ({target}) =>
        setTag(target.value);
    const handleVersionChange: ChangeEventHandler<HTMLInputElement> = ({target}) =>
        setVersion(Number(target.value));

    useEffect(() => {
        if (importSource) {
            setImportDatabase(getDatabase(getApp(), databaseSources[importSource]));
        }
    }, [importSource]);
    useEffect(() => {
        if (importDatabase) {
            get(ref(importDatabase, "projects")).then(snapshot => {
                setImportProjects(snapshot.val() || {});
            }).catch(error => {
                console.error(error);
            });
        }
    }, [importDatabase]);
    return (
        <Dialog onClose={onClose}>
            <DialogTitle>Import from a development project</DialogTitle>
            <DialogContent>
                <Box display="flex">
                    <Box flexGrow={1} m={1}>
                        <TextField label="Source deployment" onChange={handleImportDeploymentChange} select fullWidth
                                   size="small" value={importSource} sx={{m:1}}>
                            {sources.map(key => {
                                return (
                                    <MenuItem key={key} value={key}>
                                        {key}
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                        <TextField disabled={importSource === undefined} fullWidth label="Source project" sx={{m:1}}
                                   onChange={handleImportProjectChange} select size="small" value={importProject}>
                            {Object.keys(importProjects || {}).map(key => {
                                const project = importProjects![key];
        
                                return (
                                    <MenuItem key={key} value={key}>
                                        {project.name}
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                        <TextField fullWidth label="Version" onChange={handleVersionChange} size="small" sx={{m:1}}
                                   type="number" value={version}/>
                        <TextField fullWidth label="Tag" onChange={handleTagChange} size="small" sx={{m:1}}
                                   value={tag}/>
                        {importPending ?
                            <Button>
                                <Stop/>
                                <CircularProgress color="inherit" size={24} variant="determinate" value={importPending}
                                                  style={{position: "absolute", zIndex: 1}}/>
                            </Button>
                            :
                            <Button disabled={importProject === ""} onClick={handleImportClick} variant="contained" sx={{m:1}}>
                                Import
                            </Button>}
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
const mapStateToProps = (store: never) => ({
    user: selectUserId(store),
});

export default connect(mapStateToProps, {
})(ImportProjectDialog);
